export default {
	ASSETS: 'Assets',
	MODAL_TIP:
		'Use Auto resize column to automatically downscale original image into 2 smaller images!',
	TOOLTIP_NO_METADATA: 'No metadata'
};
